import type { SpaceDTO } from '@next-space/fe-api-idl';
import type { StoreUsers } from 'src/redux/reducers/users';
import { cache } from 'src/redux/store';
import { useFuSelector } from 'src/services/store-context/use-fine-context-selector';
import { getCurrentSpace, useCurrentSpace } from './use-current-space';

const getSpaceUsers = (space: SpaceDTO, users: StoreUsers) => {
  const spaceUsers: StoreUsers = {};
  space.permissions?.forEach((permission) => {
    if (permission.type === 'user' && permission.userId) {
      const user = users[permission.userId];
      if (user) {
        spaceUsers[permission.userId] = user;
      }
    }
  });
  return spaceUsers;
};

/** 获取当前空间内有权限的用户 */
export const useCurrentSpaceUsers = () => {
  const currentSpace = useCurrentSpace();
  return useFuSelector((state) => getSpaceUsers(currentSpace, state.users));
};

export const useCurrentSpaceUserSize = () => {
  const currentSpace = useCurrentSpace();
  return useFuSelector((state) => {
    const spaceUsers = getSpaceUsers(currentSpace, state.users);
    return Object.keys(spaceUsers).length;
  });
};

export const getCurrentSpaceUsers = () => {
  const currentSpace = getCurrentSpace();
  return getSpaceUsers(currentSpace, cache.users);
};
